import { render, staticRenderFns } from "./HeadBuyerShippingAddressModal.vue?vue&type=template&id=43e97b16&scoped=true&lang=pug"
import script from "./HeadBuyerShippingAddressModal.vue?vue&type=script&lang=js"
export * from "./HeadBuyerShippingAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e97b16",
  null
  
)

export default component.exports